import React from "react";
import asPage from "components/core/as-page";
import Breadcrumbs from "components/core/breadcrumbs";
import Header from "components/core/header";
import HeaderBanner from "components/core/header-banner";
import Layout from "components/core/layout";
import Preloader from "components/elements/preloader";
import Confirmation from "components/register/confirmation";
import Form from "components/register/form";
import ThankYou from "components/register/thank-you";
import onlyLoggedOut from "helpers/access-restrictions/only-logged-out";
import scrollToElem from "helpers/scroll-to-elem";
import Error from "pages/_error";
import Api from "services/api";

class SignUp extends React.Component {
  static getInitialProps({ res, query }) {
    return new Promise((resolve) => {
      const type = query.type ? query.type[0] : undefined;
      let statusCode = 200;

      if (type && type !== "seller" && type !== "buyer") {
        statusCode = 404;

        if (res) {
          res.statusCode = statusCode;
        }
      }

      resolve({
        accountType: type,
        status: statusCode,
      });
    });
  }

  constructor(props) {
    super(props);
    this.api = new Api();
    this.state = {
      step: 1,
      form: {},
      shouldCreate: false,
      notification: {},
      preloader: false,
    };
  }

  createUser() {
    const request = this.state.form;

    this.setState({
      preloader: true,
    });

    this.api
      .post("/users/register", request)
      .then(() => {
        this.setState({
          step: 3,
          shouldCreate: false,
          preloader: false,
        });
      })
      .catch((error) => {
        this.setState({
          step: 1,
          shouldCreate: false,
          notification: {
            type: "danger",
            message: error.data.message,
          },
          preloader: false,
        });
      });
  }

  handleStepChange(newState) {
    this.setState(newState, () => {
      if (this.state.step === 2 && this.state.shouldCreate) {
        this.createUser();
      }
    });

    scrollToElem(this.container);
  }

  render() {
    const { step, form, notification, preloader } = this.state;
    const { status, accountType } = this.props;

    if (status !== 200) {
      return <Error statusCode={status} />;
    }

    return (
      <Layout className="register" title="Register">
        <Header>
          <HeaderBanner
            title="Register"
            icon="key"
            background="/static/images/header-sign-in.jpg"
          />
        </Header>

        <div
          ref={(container) => {
            this.container = container;
          }}
        >
          <Breadcrumbs>
            <Breadcrumbs.Item title="Register" url="register" />
          </Breadcrumbs>

          <div className="register__content">
            {!preloader && step === 1 && (
              <Form
                defaultAccountType={accountType}
                form={form}
                error={notification}
                onStepChange={(newState) => this.handleStepChange(newState)}
              />
            )}

            {!preloader && step === 2 && (
              <Confirmation
                form={form}
                onStepChange={(newState) => this.handleStepChange(newState)}
              />
            )}

            {!preloader && step === 3 && <ThankYou form={form} />}

            <Preloader show={preloader} />
          </div>
        </div>
      </Layout>
    );
  }
}

export default asPage(SignUp, onlyLoggedOut);
